import {
  SELECT_PACK,
  ADD_ACCESSORY,
  REMOVE_ACCESSORY,
  SET_COLOUR,
  SET_MODEL,
  RESET_BIKE,
  RESET_ACCESSORIES,
  INCREASE_ACCESSORY_QUANTITY,
  DECREASE_ACCESSORY_QUANTITY,
  SET_CONFLICT_CHOICE,
  RESOLVE_ACCESSORY_CONFLICT,
  TOGGLE_REQUIRES_ALL_CONFIRMED,
  SET_REQUIRES_SINGLE_CHOICE,
  RESOLVE_ACCESSORIES_REQUIRED,
  CLOSE_ACCESSORY_RESOLUTION,
  REMOVE_REQUIRED_ACCESSORIES,
  REFRESH_BIKE_ACCESSORIES,
  REMOVE_PACK,
  LOAD_CONFIGURATION,
  RESOLVE_ACCESSORY_PACK_CONFLICT,
  RESOLVE_PACK_ACCESSORY_CONFLICT,
  SET_PREVIEWED_PACK,
  ADD_PACK_ACCESSORY,
  REMOVE_PACK_ACCESSORY,
  CLEAR_PREVIEWED_PACK,
  UPDATE_PACK_ACCESSORIES,
  CLOSE_REQUIRED_RESOLUTION,
  ADD_WARRANTY_PACK,
  REMOVE_WARRANTY_PACK,
  ADD_SERVICE_PACK,
  REMOVE_SERVICE_PACK,
} from './types';

export const selectPack = payload => ({
  type: SELECT_PACK,
  payload,
});

export const addAccessory = payload => ({
  type: ADD_ACCESSORY,
  payload,
});

export const removeAccessory = payload => ({
  type: REMOVE_ACCESSORY,
  payload,
});

export const addWarrantyPack = payload => ({
  type: ADD_WARRANTY_PACK,
  payload,
});

export const removeWarrantyPack = payload => ({
  type: REMOVE_WARRANTY_PACK,
  payload,
});

export const addServicePack = payload => ({
  type: ADD_SERVICE_PACK,
  payload,
});

export const removeServicePack = payload => ({
  type: REMOVE_SERVICE_PACK,
  payload,
});

export const setColour = payload => ({
  type: SET_COLOUR,
  payload,
});

export const setModel = payload => ({
  type: SET_MODEL,
  payload,
});

export const resetBike = () => ({
  type: RESET_BIKE,
});

export const resetAccessories = () => ({
  type: RESET_ACCESSORIES,
});

export const increaseAccessoryQuantity = payload => ({
  type: INCREASE_ACCESSORY_QUANTITY,
  payload,
});

export const decreaseAccessoryQuantity = payload => ({
  type: DECREASE_ACCESSORY_QUANTITY,
  payload,
});

export const setConflictChoice = payload => ({
  type: SET_CONFLICT_CHOICE,
  payload,
});

export const resolveAccessoryConflict = payload => ({
  type: RESOLVE_ACCESSORY_CONFLICT,
  payload,
});

export const resolveAccessoriesRequired = payload => ({
  type: RESOLVE_ACCESSORIES_REQUIRED,
  payload,
});

export const toggleRequiresAllConfirmed = () => ({
  type: TOGGLE_REQUIRES_ALL_CONFIRMED,
});

export const setRequiresSingleChoice = payload => ({
  type: SET_REQUIRES_SINGLE_CHOICE,
  payload,
});

export const closeAccessoryResolution = () => ({
  type: CLOSE_ACCESSORY_RESOLUTION,
});

export const removeRequiredAccessories = () => ({
  type: REMOVE_REQUIRED_ACCESSORIES,
});

export const refreshBikeAccessories = payload => ({
  type: REFRESH_BIKE_ACCESSORIES,
  payload,
});

export const resolveAccessoryPackConflict = () => ({
  type: RESOLVE_ACCESSORY_PACK_CONFLICT,
});

export const resolvePackAccessoryConflict = () => ({
  type: RESOLVE_PACK_ACCESSORY_CONFLICT,
});

export const removePack = () => ({
  type: REMOVE_PACK,
});

export const loadConfiguration = payload => ({
  type: LOAD_CONFIGURATION,
  payload,
});

export const setPreviewedPack = payload => ({
  type: SET_PREVIEWED_PACK,
  payload,
});

export const clearPreviewedPack = () => ({
  type: CLEAR_PREVIEWED_PACK,
});

export const addPackAccessory = payload => ({
  type: ADD_PACK_ACCESSORY,
  payload,
});

export const removePackAccessory = payload => ({
  type: REMOVE_PACK_ACCESSORY,
  payload,
});

export const updatePackAccessories = payload => ({
  type: UPDATE_PACK_ACCESSORIES,
  payload,
});

export const closeRequiredResolution = () => ({
  type: CLOSE_REQUIRED_RESOLUTION,
});
